/**
 * Règles d'affichage partagées des références juridiques.
 * Source unique de vérité : un numéro de pourvoi relève de l'ordre judiciaire,
 * jamais d'une juridiction administrative. Tout point d'affichage doit passer
 * par ces fonctions.
 */

import { formatCourtLabel } from "@/lib/court-formatting";

/** Numéro de pourvoi (ordre judiciaire) : 22-18.758, 19-13317, 19-13.1888… */
export const POURVOI_RE = /^\s*\d{2}[-–]\d{2}[.\s-]?\d{3,5}\s*$/;

export const ADMIN_COURT_RE =
  /tribunal administratif|cour administrative|conseil d['’]?\s?[ée]tat/i;

/**
 * Neutralise un intitulé de juridiction incohérent avec le numéro cité.
 * En cas d'incohérence, on n'invente pas : on affiche « Décision de justice ».
 */
export function sanitizeCaselawTitle(title: string, number: string): string {
  if (!POURVOI_RE.test(number || "")) return title;
  const parts = (title || "").split(",").map((p) => p.trim()).filter(Boolean);
  if (parts.length === 0 || !ADMIN_COURT_RE.test(parts[0])) return title;
  return ["Décision de justice", ...parts.slice(1)].join(", ");
}

export const LEGAL_STATUS_LABELS: Record<string, string> = {
  VIGUEUR: "en vigueur",
  VIGUEUR_DIFF: "entrée en vigueur différée",
  ABROGE: "abrogé",
  ABROGE_DIFF: "en vigueur, abrogation différée",
  PERIME: "périmé",
  ANNULE: "annulé",
  MODIFIE: "modifié",
  TRANSFERE: "transféré",
  DISJOINT: "disjoint",
  SANS_ETAT: "",
};

export function humanizeOfficialTitle(title: string): string {
  if (!title) return title;
  // Les formations renvoyées sous forme d'énumération (« CHAMBRE_SOCIALE »)
  // ne doivent jamais atteindre l'écran.
  let out = formatCourtLabel(title).replace(/\(([A-Z_]+)\)/g, (m, code) => {
    if (code in LEGAL_STATUS_LABELS) {
      const label = LEGAL_STATUS_LABELS[code];
      return label ? `(${label})` : "";
    }
    return m;
  });
  out = out.replace(/-\s*-/g, "-").replace(/\s{2,}/g, " ").replace(/\s+-\s*$/, "").trim();
  return out;
}

